import React from 'react';

import Resources from "../Resources";

function createColumnDefs() {
  const columnDefs = [
    { name: 'ResourceId', options: { display: true, filter: false } },
    { name: 'ClientAccountId', options: { display: false, filter: true } },
    { name: 'Description', options: { display: true, filter: true } },
    { name: 'SubscribedResource.ResourceId', label: 'Subject', options: { filter: true } },
    { name: 'SubscribedResource.Prefix', label: 'Prefix', options: { filter: true } },
    { name: 'SubscribedResource.Suffix', label: 'Suffix', options: { filter: true } },
    { name: 'ResourceType', options: { display: false, filter: false } },
    { name: 'DeliveryConfiguration.Status', label: 'Status', options: { filter: true } },
    { name: 'StackUpdated', options: { display: true } },
  ];
  return columnDefs;
}

export default function Subscriptions(props) {

  const columnDefs = createColumnDefs();

  return (
    <Resources 
      type='Subscription' 
      columnDefs={columnDefs} 
    />
  );
}

Subscriptions.propTypes = {
};

Subscriptions.defaultProps = {
};
